import * as Styles from './styles'
import CompletedImg from './assets/completed.png'
export const SuccessBox = () => {
  return (
    <Styles.CompletedContainer>
      <Styles.Image src={CompletedImg} />
    </Styles.CompletedContainer>
  )
}
